export const money = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 2 }).format(
    Number(n) || 0
  );

export const num = (n) => new Intl.NumberFormat("es-MX").format(Number(n) || 0);

export const fdate = (d) => {
  if (!d) return "—";
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const date = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(s);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("es-MX", { year: "numeric", month: "short", day: "2-digit" });
};

export const periodLabel = (p) => {
  if (!p) return "—";
  const [y, m] = p.split("-");
  const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
  return `${meses[parseInt(m, 10) - 1]} ${y}`;
};
